import React from "react";

const ChrWidgetLoader = (props) => {
  const { loadersCount, additionalClassNames } = props;
  const loaders = [...Array(loadersCount).keys()].map((index) => <div className={`cui-widget-loader mr-auto ${additionalClassNames}`} key={ index }/> );

  return (
    <div className="d-flex flex-wrap">
      {
        loaders
      }
    </div>
  )
}

export default ChrWidgetLoader;
